export default  {

  gray: "#d9d9d9",
  white: "#FFFFFF",
  grayShade1:"#8f8f8f",
  lightBlue:"#e6f7ff",
  green:"#39b54a",
  green1:"#4cba5b",
  green2:"#166838",
  black:"#000000"
      
  
  }